import { render, staticRenderFns } from "./page-header-spot-list.vue?vue&type=template&id=7ac0c834&scoped=true"
import script from "./page-header-spot-list.vue?vue&type=script&lang=js"
export * from "./page-header-spot-list.vue?vue&type=script&lang=js"
import style0 from "./page-header-spot-list.vue?vue&type=style&index=0&id=7ac0c834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac0c834",
  null
  
)

export default component.exports